/**
 *  @class
 *  @function Gallery
 */
if (!customElements.get('theme-gallery')) {
  class ThemeGallery extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.galleryVideoList = Array.from(this.querySelectorAll('.gallery--item .gallery--video'));

      this.hoverPlayList = this.galleryVideoList.filter((item) => {
        return item.classList.contains('hover-play') && item;
      });

      this.autoPlayList = this.galleryVideoList.filter((item) => {
        return !item.classList.contains('hover-play') && item;
      });

      this.autoPlayList.forEach((item, i) => {
        item.querySelector('video').play();
      });

      this.scrollTween();
      
      this.setHoverPlayList();

      this.setAnimations();

      if (Shopify.designMode) {
        this.addEventListener('shopify:section:load', (event) => {
          this.setAnimations();

          setTimeout(() => {
            ScrollTrigger.refresh();
          }, 100);
        });
      }
    }

    setHoverPlayList() {
      this.hoverPlayList.forEach((item, i) => {
        item.querySelector('video').currentTime = 0.1;
        item.parentElement.addEventListener('mouseenter', () => this.playVideo(item));
        item.parentElement.addEventListener('mouseleave', () => this.pauseVideo(item));
      });
    }

    scrollTween(){
      let triggerInstance;
      ScrollTrigger.matchMedia({
      "(max-width: 768px)": () => {
        if (!this.classList.contains("swipe-on-mobile")) return;
        let gallerTrigger = this.querySelector('.scroll-swipe');
        let galleryList = gsap.utils.toArray(this.querySelectorAll(".scroll-swipe .gallery--item"));
        triggerInstance = gsap.to(galleryList, {
          xPercent: -100 * (galleryList.length - 1),
          ease: "none",
          scrollTrigger: {
            trigger: gallerTrigger,
            scrub: 1,
            start: "top center",
            end: () => "+=" + this.offsetWidth
          }
        });
      },

      "(min-width: 769px)": () => {
        // 清理 scrollTrigger 实例（可选）
        if (triggerInstance?.scrollTrigger) {
          triggerInstance.scrollTrigger.kill();
        }
      }
    });
    }

    playVideo(videoContainer) {
      videoContainer.querySelector('video').play();
    }
    pauseVideo(videoContainer) {
      videoContainer.querySelector('video').pause();
    }

    setAnimations() {
      ScrollTrigger.batch(this.querySelectorAll('figure'), {
        start: "top 90%",
        onEnter: (elements, triggers) => {
          gsap.to(elements, { opacity: 1, stagger: 0.15, ease: window.theme.settings.animation_easing });
        },
      });
    }
  }
  customElements.define('theme-gallery', ThemeGallery);
}